import styled from "styled-components"
import firstcry from '../images/firstCry.png'
import hotstar from '../images/hotstart.png'
import ketto from '../images/ketto.png'
import nodeStrom from '../images/nordstrom_Screenshot.png'
import techtrove from '../images/techTrove.png'
import youtube from '../images/youtube.png'
import zara from '../images/Zara.png'
import githubstatus from '../images/gitstatus.png'

export const Projects = () => {
    return (
        <DIV id='projects'>
            <h1>Projects</h1>
            <div className="project_div">
                <div className="img_div">
                    <img src={firstcry} alt="" />
                </div>
                <div className="content_div">
                    <h3>FirstCry</h3>
                    <p>An E-Commerce website, Where user can buy newborn, baby and kids products.</p>
                    <p>Individual Project</p>
                    <h4>CSS, HTML, JavaScript, React, Chakra UI</h4>
                    <div className="button_div">
                        <button><a href="https://github.com/amir241297/whispering-station-4511/tree/master/little_gift">Github</a></button>
                        <button>
                            <a href="https://polite-kleicha-11ec23.netlify.app/">Live</a>
                        </button>
                    </div>

                </div>
            </div>

            <div className="project_div">
                <div className="img_div">
                    <img src={hotstar} alt="" />
                </div>
                <div className="content_div">
                    <h3>HotStart</h3>
                    <p>An Entertainment website, Where user can see movies, cricket and webseries.</p>
                    <p>Individual Project</p>
                    <h4>CSS, HTML, JavaScript</h4>
                    <div className="button_div">
                        <button><a href="">Github</a></button>
                        <button>
                            <a href="https://extraordinary-cat-f612ef.netlify.app/">Live</a>
                        </button>
                    </div>

                </div>
            </div>

            <div className="project_div">
                <div className="img_div">
                    <img src={ketto} alt="" />
                </div>
                <div className="content_div">
                    <h3>Ketto</h3>
                    <p>It is a Crowdfunding & Medical Fundraised website. Where the people raise fund.</p>
                    <p>Individual Project</p>
                    <h4>CSS, HTML</h4>
                    <div className="button_div">
                        <button><a href="https://github.com/amir241297/tops-picture-5211">Github</a></button>
                        <button>
                            <a href="https://helpful-naiad-08bcfd.netlify.app/">Live</a>
                        </button>
                    </div>

                </div>
            </div>

            <div className="project_div">
                <div className="img_div">
                    <img src={nodeStrom} alt="" />
                </div>
                <div className="content_div">
                    <h3>NordStrom</h3>
                    <p>An E-Commerce website, Where user can buy multiple levels of Products, clothes, shoe and toys.</p>
                    <p>Group Project</p>
                    <h4>CSS, HTML, JavaScript, React</h4>
                    <div className="button_div">
                        <button><a href="https://github.com/Anish-Jha/Nordstormrack.com">Github</a></button>
                        <button>
                            <a href="https://incandescent-truffle-b1c618.netlify.app/">Live</a>
                        </button>
                    </div>

                </div>
            </div>

            <div className="project_div">
                <div className="img_div">
                    <img src={techtrove} alt="" />
                </div>
                <div className="content_div">
                    <h3>TechTrove</h3>
                    <p>Product-based E-Commerce website that sell multiple levels of Products.</p>
                    <p>Group Project</p>
                    <h4>CSS, Chakra UI, JavaScript, React, Redux</h4>
                    <div className="button_div">
                        <button><a href="https://github.com/sachitsingh777/shivering-haircut-3518/tree/main/techtrove">Github</a></button>
                        <button>
                            <a href="https://647725d506c6800526070f4b--extraordinary-stroopwafel-59ad38.netlify.app/">Live</a>
                        </button>
                    </div>

                </div>
            </div>

            <div className="project_div">
                <div className="img_div">
                    <img src={youtube} alt="" />
                </div>
                <div className="content_div">
                    <h3>YouTube</h3>
                    <p>An Entertainment website. Where the users can watch multiple levels of video.</p>
                    <p>Individual Project</p>
                    <h4>CSS, HTML, JavaScript, api</h4>
                    <div className="button_div">
                        <button><a href="">Github</a></button>
                        <button>
                            <a href="https://statuesque-kulfi-a03cbd.netlify.app/">Live</a>
                        </button>
                    </div>

                </div>
            </div>

            <div className="project_div">
                <div className="img_div">
                    <img src={zara} alt="" />
                </div>
                <div className="content_div">
                    <h3>Zara</h3>
                    <p>An E-Commerce website, Where user can buy multiple levels of products.</p>
                    <p>Individual Project</p>
                    <h4>CSS, HTML</h4>
                    <div className="button_div">
                        <button><a href="https://github.com/amir241297/grubby-mitten-8672">Github</a></button>
                        <button>
                            <a href="https://rainbow-bunny-36c7ee.netlify.app/">Live</a>
                        </button>
                    </div>

                </div>
            </div>
            <hr />
            <div className="github_status">
                <h1>GitHub Status</h1>
                <img src={githubstatus} alt="" />
            </div>
            <div className="stats">
                <img src='https://github-readme-stats.vercel.app/api?username=amir241297&theme=radical' />
                <img src='https://camo.githubusercontent.com/9386e480e113cd1156cc22b3de6e8f438f5b0658199903cdf9d7816bcc91d1b3/687474703a2f2f6769746875622d70726f66696c652d73756d6d6172792d63617264732e76657263656c2e6170702f6170692f63617264732f70726f66696c652d64657461696c733f757365726e616d653d616d6972323431323937267468656d653d7261646963616c' />
                <img src='https://github-readme-stats-sigma-five.vercel.app/api/top-langs/?username=amir241297&langs_count=8&count_private=true&layout=compact&theme=react&hide_border=true&bg_color=0D1117' />
            </div>

        </DIV>
    )
}
const DIV = styled.div`
    margin-top: 100px;
    h1{
        font-size: 40px;
        font-weight: bold;
    }
   
    .content_div>h3{
        font-size: 20px;
        font-weight: 500;
        align-items: center;
        width: 100%;
        margin-bottom:10px;
    }
    .content_div>p{
        font-size: 18px;
        width: 100%;
        /* border:1px solid green; */
    }
    .content_div>p:nth-child(3){
        color: teal;
    }
    .button_div{
        display: flex;
        margin-top: 10px;
        width: 100%;
        justify-content: space-evenly;
    }
    .button_div>button{
        font-weight: bold;
        font-size:20px;
        box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;
        padding: 15px;
        border-radius: 5px;
        height: 40px;
        display: flex;
        align-items: center;
    }
    .button_div>button:hover{
        background-color:blueviolet;
    }
    
    .github_status{
        width: 60%;
        margin: auto;
    }
   

    
    @media (max-width: 768px) { 
    /* screen width is less than 480px (Phone) */
    
    width:100%;
    h1{
        font-size: 30px;
        font-weight:600;
        
    }
    .project_div{
        margin: 50px 5%;
        display: flex;
        flex-direction: column;
        width: 90%;
        padding: 1%;
        box-shadow: rgba(0, 0, 0, 0.25) 0px 0.0625em 0.0625em, rgba(0, 0, 0, 0.25) 0px 0.125em 0.5em, rgba(255, 255, 255, 0.1) 0px 0px 0px 1px inset;
    }
    .img_div{
        width: 100%;
    }
    .content_div{
        line-height: 37px;
        padding: 10px;
    }
    .stats{
        width: 70%;
        margin-top: 70px;
        display: flex;
        flex-direction: column;
        margin: auto;
    }
    .stats>img{
        margin-top: 50px;
    }
    .github_status>h1{
        margin: 30px 0px;
        font-size: 22px;
        width: 100%;
        
    }

    }
    
    @media (min-width: 769px) and (max-width: 1200px) {
    /* screen width is between 769px (medium) and 1024px (large) (Tablet)*/
    width:100%;
    /* margin: auto; */
    h1{
        font-size: 50px;
        margin-bottom: 50px;
        font-weight: 500;
    }
    .project_div{
        display: flex;
        flex-direction: column;
        width: 70%;
        margin: auto;
        margin-bottom:50px ;
        padding: 5%;
        box-shadow: rgba(0, 0, 0, 0.25) 0px 0.0625em 0.0625em, rgba(0, 0, 0, 0.25) 0px 0.125em 0.5em, rgba(255, 255, 255, 0.1) 0px 0px 0px 1px inset;
    }
    .img_div{
        width: 100%;
    }
    .content_div{
        line-height: 37px;
        padding: 10px;
    }
    .stats{
        width: 70%;
        margin-top: 70px;
        display: flex;
        flex-direction: column;
        margin: auto;
    }
    .stats>img{
        margin-top: 50px;
    }
    
    }
    @media (min-width: 1201px){ 
    /* screen width is greater than 1200px (large) */
    .project_div{
        margin: 50px 15%;
        display: flex;
        width: 70%;
        padding: 1%;
        box-shadow: rgba(0, 0, 0, 0.25) 0px 0.0625em 0.0625em, rgba(0, 0, 0, 0.25) 0px 0.125em 0.5em, rgba(255, 255, 255, 0.1) 0px 0px 0px 1px inset;
    }
    .img_div{
        width: 60%;
    }
    .content_div{
        width: 40%;
        display: flex;
        flex-direction: column;
        margin: auto;
        line-height: 37px;
        padding-left: 10px;;
    }
    .stats{
        width: 100%;
        margin-top: 70px;
        display: flex;
        justify-content: space-between;
    }
    }


 `